import React from 'react';
import { Form, Select } from 'antd';

import { voivodeship } from '../../../../../consts/voivodeships';

const Voivodeship = () => {
    return (
        <Form.Item
            label="Województwo"
            name="voivodeship"
            rules={[
                {
                    required: true,
                    message: 'Proszę wybrać województwo',
                },
            ]}
        >
            <Select
                showSearch
                optionFilterProp="label"
                allowClear
                options={voivodeship}
            />
        </Form.Item>
    );
};

export default Voivodeship;
